import { useQuery } from '@tanstack/react-query';
import { getCitizenDetails } from '../firebase-client';

export const useCitizensQuery = ({ city }) => {
  const citizenDetailsQuery = useQuery({
    queryKey: ['citizenDetails', city?.id],
    queryFn: () => getCitizenDetails(city?.citizens || [], city?.index),
    enabled: city?.id && (city?.citizens || []).length > 0,
  });

  return citizenDetailsQuery;
};

export const useRenterDetailsQuery = ({ city }) => {
  const renterDetailsQuery = useQuery({
    queryKey: ['renterDetails', city?.id],
    queryFn: () => getCitizenDetails(city?.renters || [], city?.index),
    enabled: city?.id && (city?.renters || []).length > 0,
  });

  return renterDetailsQuery;
};
